import { render } from "./AnnualReviewsItem.vue?vue&type=template&id=4ba5add5"
import script from "./AnnualReviewsItem.vue?vue&type=script&lang=js"
export * from "./AnnualReviewsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__